module.exports = __webpack_public_path__ + "img/percent-port.f534bd95.svg";